import { TableCell } from "@mui/material"
import { type Row, flexRender } from "@tanstack/react-table"
import React, { type ReactElement } from "react"

import { DraggableRow } from "@/components/Tables/Aeros/components/DraggableRow"

interface DraggableRowContentProps<TData> {
  row: Row<TData>
  rowKey: string
  rowProps?: React.HTMLAttributes<HTMLTableRowElement>
}

export const DraggableRowContent = <TData,>({
  row,
  rowKey,
  rowProps = {},
}: DraggableRowContentProps<TData>): ReactElement => {
  return (
    <DraggableRow key={rowKey} id={rowKey} {...rowProps}>
      {({ listeners }) => (
        <>
          {row.getVisibleCells().map((cell) => {
            const align = cell.column.id === "select" || cell.column.id === "drag" ? "center" : "left"
            const cellContent = flexRender(cell.column.columnDef.cell, {
              ...cell.getContext(),
              ...(cell.column.id === "drag" && { listeners }),
            })

            return (
              <TableCell key={cell.id} align={align}>
                {cellContent}
              </TableCell>
            )
          })}
        </>
      )}
    </DraggableRow>
  )
}
